import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '@material/web/progress/linear-progress.js';
import '@material/web/progress/circular-progress.js';

export class IxProgress extends LitElement {
  /**
   * Progress to display, a fraction between 0 and `max`.
   */
  @property({ type: Number }) value = 0;

  /**
   * A buffer to communicate both determinate and indeterminate progress.
   */
  @property({ type: Number }) buffer = 1;

  /**
   * Maximum progress to display, defaults to 1.
   */
  @property({ type: Number }) max = 1;

  /**
   * To show loading or progress state.
   * Set to true for loading state. Set to false for progress bar.
   */
  @property({ type: Boolean }) indeterminate = false;

  /**
   * To choose between linear or circular progress bar.
   */
  @property({ type: Boolean }) linear = true;

  /**
   * Whether or not to render indeterminate mode using 4 colors instead of one.
   */
  @property({ type: Boolean }) fourColor = false;

  /**
   * Label to display inside the progress bar.
   */
  @property({ type: String }) label = '';

  renderProgressBar() {
    let comp;
    if (this.linear) {
      comp = html`<md-linear-progress
        style="width: initial"
        .buffer="${this.buffer}"
        .value="${this.value}"
        .max="${this.max}"
        .indeterminate="${this.indeterminate}"
        .fourColor="${this.fourColor}"
      ></md-linear-progress>`;
    } else {
      comp = html`<md-circular-progress
        .value="${this.value}"
        .max="${this.max}"
        .indeterminate="${this.indeterminate}"
        .fourColor="${this.fourColor}"
      ></md-circular-progress>`;
    }
    return html`${comp}`;
  }

  render() {
    return html`
      <div>
        <div class="progress__description">${this.label}</div>
        ${this.renderProgressBar()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ix-progress': IxProgress;
  }
}
